<template>
  <div class="d-flex flex-column" dir="rtl">
    <div class="dflex dflex-row">
      <!-- <div class="f20-l20 pointer" @click="$emit('close')">X</div> -->
      <div v-if="wizard.steps.length > 1"  class="text-center f14-l17 df28-l40-l">{{progressLabel}}</div>
      </div>
    <form class="formfield-round-border" :method="formMethod" ref="form" :action="formAction" @change="onFormChange" @input="onFormChange">
      <div v-for="(step,idx) in wizard.steps" :key="idx" :ref="`step` + idx" v-show="idx==activeStep" class="margin-top-20">
        <div class="d-flex flex-column">
          <div class="d-flex flex-row">
            <div v-if="stepHistory.length > 0 && !step.skip?.hide" class="f20-l20-b red pointer" @click="wizardSkip(-1)">&lt;</div>
            <div v-if="step.title"  class="text-center f20-l20-b df30-l30-b flex-grow-1">{{step.title}}</div>
            <SvgImage v-if="step.icon" :src="step.icon.src" style="height: 130px;" class="margin-top-5 mx-auto align-self-center" />
            <div v-if="step.skip" class="f16-l10 red pointer" @click="wizardSkip(1)">{{step.skip.label}}</div>
          </div>
          <div class="text-center f14-l17 margin-top-10" v-html="step.description"></div>
          <div class="margin-top-20"></div>
          <div v-if="step.form">
            <template v-for="(field,idx2) in step.form.fields" :key="idx2">
              <FormFieldComponent v-if="shouldShowField(field)" :field="field" class="formfield-round-border" />
            </template>
          </div>
        </div>
        <ButtonComponent v-if="step.next" :caption="step.next.label" @click="wizardSkip(1)" @keyup.enter="wizardSkip(1)" class="margin-top-20" />
        <div v-if="step.submit && !step.submit.hide && blankErrorField?.error_blank && isFieldBlank(blankErrorField)" class="f14-l17 red text-center margin-top-10" v-html="blankErrorField.error_blank"></div>
        <ButtonComponent v-if="step.submit && !step.submit.hide" :caption="step.submit.label" @click="onSubmit(step)" @keyup.enter="onSubmit(step)" class="margin-top-20" />
        <ButtonComponent v-if="step.cancel" :caption="step.cancel.label" @click="$emit('close')" class="margin-top-20" />
      </div>
    </form>
  </div>
</template>
<script>
import {formSubmit} from '@/modules/configuration.js'
import FormFieldComponent from "@/components/form/FormFieldComponent";
import ButtonComponent from "@/components/form/ButtonComponent"
import SvgImage from "@/components/generic/SvgImage.vue"
export default {
  emits: ['close','submit'],
  components: {
    FormFieldComponent,
    ButtonComponent,
    SvgImage
  },
  props: {
    wizard: Object,
    formMethod: {
      type: String,
      default: 'GET'
    }
  },
  data() {
    return {
      activeStep: 0,
      stepHistory: [],
      formVersion: 0,
      blankErrorField: null,
    }
  },
  computed: {
    stepIndexById() {
      const map = {};
      (this.wizard?.steps || []).forEach((step, idx) => {
        if (step?.id) map[step.id] = idx;
      });
      return map;
    },
    isBranchedWizard() {
      return (this.wizard?.steps || []).some((step) => {
        if (step.default_next_step_id) return true;
        return (step.form?.fields || []).some((field) => (field.options || []).some((opt) => opt.next_step_id));
      });
    },
    progressLabel() {
      if (!this.isBranchedWizard) {
        return `${this.activeStep + 1}/${this.wizard.steps.length}`;
      }
      return `${this.stepHistory.length + 1}`;
    },
    formAction() {
      const steps = this.wizard?.steps || [];
      const submitStep = steps.find((step) => step.submit?.href);
      return submitStep ? submitStep.submit.href : (steps[steps.length - 1]?.submit?.href || '');
    },
  },
  methods: {
    wizardSkip(s) {
      if (s > 0) {
        this.goNext();
      } else {
        this.goBack();
      }
    },
    goNext() {
      const currentStep = this.wizard.steps[this.activeStep];
      const targetStepId = this.resolveNextStepId(currentStep);
      const targetIndex = (targetStepId && Object.prototype.hasOwnProperty.call(this.stepIndexById, targetStepId))
        ? this.stepIndexById[targetStepId]
        : this.activeStep + 1;
      this.stepHistory.push(this.activeStep);
      this.activeStep = targetIndex;
      this.blankErrorField = null;
    },
    goBack() {
      this.blankErrorField = null;
      if (this.stepHistory.length > 0) {
        this.activeStep = this.stepHistory.pop();
        return;
      }
      if (this.activeStep > 0) {
        this.activeStep -= 1;
      }
    },
    resolveNextStepId(step) {
      if (!step) return null;
      const fields = step.form?.fields || [];
      for (const field of fields) {
        const options = field.options;
        if (!Array.isArray(options)) continue;
        const hasBranchingOptions = options.some((opt) => opt.next_step_id);
        if (!hasBranchingOptions) continue;
        const selectedValues = this.getFieldValues(field.data_name);
        const selectedOption = options.find((opt) => selectedValues.includes(String(opt.val)));
        if (selectedOption?.next_step_id) {
          return selectedOption.next_step_id;
        }
      }
      return step.default_next_step_id || null;
    },
    getFieldValues(dataName) {
      const form = this.$refs.form;
      if (!form || !dataName) return [];
      const baseName = dataName.endsWith('[]') ? dataName.slice(0, -2) : dataName;
      const candidateNames = new Set([baseName, `${baseName}[]`]);
      const values = [];
      form.querySelectorAll('input, textarea, select').forEach((input) => {
        if (!candidateNames.has(input.name)) return;
        const type = (input.type || '').toLowerCase();
        if (type === 'checkbox' || type === 'radio') {
          if (input.checked && input.value !== '') values.push(input.value);
        } else if (type === 'hidden') {
          if (input.value !== '') values.push(input.value);
        } else if (input.tagName === 'SELECT') {
          Array.from(input.selectedOptions || []).forEach((opt) => {
            if (opt.value !== '') values.push(opt.value);
          });
        } else if (input.value !== '') {
          values.push(input.value);
        }
      });
      return values;
    },
    matchesShowWhen(showWhen) {
      if (!showWhen || !showWhen.field) return true;
      const values = this.getFieldValues(showWhen.field);
      if (Object.prototype.hasOwnProperty.call(showWhen, 'equals')) {
        return values.includes(String(showWhen.equals));
      }
      if (Object.prototype.hasOwnProperty.call(showWhen, 'includes')) {
        return values.includes(String(showWhen.includes));
      }
      if (Object.prototype.hasOwnProperty.call(showWhen, 'includes_any')) {
        const targets = Array.isArray(showWhen.includes_any) ? showWhen.includes_any : [];
        return targets.some((target) => values.includes(String(target)));
      }
      return true;
    },
    shouldShowField(field) {
      // eslint-disable-next-line no-void
      void this.formVersion;
      if (!field?.show_when) return true;
      return this.matchesShowWhen(field.show_when);
    },
    isFieldBlank(field) {
      if (!field?.data_name) return false;
      const values = this.getFieldValues(field.data_name);
      return values.length === 0 || values.every((v) => String(v).trim() === '');
    },
    requiredVisibleFields(step) {
      return (step?.form?.fields || []).filter((field) => field.required && this.shouldShowField(field));
    },
    onFormChange() {
      this.formVersion += 1;
    },
    stepElement(idx) {
      const refEl = this.$refs[`step${idx}`];
      return Array.isArray(refEl) ? refEl[0] : refEl;
    },
    visitedStepIndexes() {
      return new Set([...this.stepHistory, this.activeStep]);
    },
    setUnvisitedStepInputsDisabled(disabled) {
      const visited = this.visitedStepIndexes();
      (this.wizard?.steps || []).forEach((step, idx) => {
        if (visited.has(idx)) return;
        const el = this.stepElement(idx);
        if (!el) return;
        el.querySelectorAll('input, textarea, select').forEach((input) => {
          const type = (input.type || '').toLowerCase();
          if (type === 'hidden') return; // hidden ids (e.g. cook/dish ids) stay in the payload
          input.disabled = disabled;
        });
      });
    },
    withUnvisitedStepsOmitted(fn) {
      this.setUnvisitedStepInputsDisabled(true);
      try {
        return fn();
      } finally {
        this.setUnvisitedStepInputsDisabled(false);
      }
    },
    buildSubmitFormData() {
      return this.withUnvisitedStepsOmitted(() => new FormData(this.$refs.form));
    },
    onSubmit(step) {
      const blankField = this.requiredVisibleFields(step).find((field) => this.isFieldBlank(field));
      if (blankField) {
        this.blankErrorField = blankField;
        return;
      }
      this.blankErrorField = null;
      if (this.wizard.propagate_submit) {
        this.$emit("submit", this.buildSubmitFormData());
      } else {
        this.withUnvisitedStepsOmitted(() => formSubmit(this, this.$refs.form));
        this.$emit("close");
      }
    },
  }

}
</script>